import React from 'react';
import SearchSVG from 'assets/images/svg/SearchSVG';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        '& svg': {
            width: 14,
            height: 14,
            marginRight: 10
        }
    }
}));

function DropdownIndicator() {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <SearchSVG />
        </div>
    );
}

export default DropdownIndicator;
